export const EDUCATIONS = [
  {
    name: "College of Engineering, Guindy",
    logo: "ceg.png",
    duration: "2018 - 2022",
    degree: "Bachelor's Degree in Computer Science and Engineering",
    location: "Chennai, Tamil Nadu",
  },
  {
    name: "Sri Sowdambika M.H.S.S",
    logo: "school.png",
    duration: "2016 - 2018",
    degree: "Higher Secondary Education",
    location: "Virudhunagar, Tamil Nadu",
  },
];
